import React, { Fragment, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import ScheduleAdminButtons from "../../components/buttons/ScheduleAdminButtons";
import { BasicContext } from "../../App";
import moment from "moment";
import SignUpForClassBtns from "../../components/buttons/SignUpForClassBtns";
import { postMethod } from "../../requests";
import { FrontOfficeContext } from "../student/FrontOffice";
import { BackOfficeContext } from "../admin/BackOffice";
import SignOutFromClassModal from "../../components/modals/SignOutFromClassModal";

const ActionBtns = (props) => {
    const { t } = useTranslation();
    const { c, j, getSchedule, filterDates, setLoading, reloadData, permissions } = props;
    const { showView, checkServerData, setAlerts, changeView } = useContext(BasicContext);
    const [disableBtn, setDisableBtn] = useState(false);
    const [showSignOutModal, setShowSignOutModal] = useState(false);
    const { settings } = useContext(showView ? (showView.params.moduleName === "APP" ? FrontOfficeContext : BackOfficeContext) : null);

    const signOutFromClass = async (c) => {
        //console.log({ classID: c.class_id, u2cID: c.ifUserIsAssigned.u2c_id, startTime: c.class_start_time });
        const res = await postMethod("/sign-out-from-class", { classID: c.class_id, u2cID: c.ifUserIsAssigned.u2c_id, startTime: c.class_start_time });
        if (checkServerData(res)) {
            setAlerts([{ variant: res.data.status, message: t(`${res.data.status}.${res.data.code}`), fading: res.data.status === "success" ? 1500 : null, id: "signout" }]);
            setShowSignOutModal(false);
            reloadData();
        }
    };

    const getReservationDetails = async (classID) => {
        const res = await postMethod("/get-not-used-reservation-details", { classID: classID });
        if (checkServerData(res)) {
            changeView({ nav: "reservations", sub: "useReservation", params: { reserv: res.data.reserv } });
        }
    };

    return (
        <Fragment>
            {showView.params.moduleName === "APP" && (
                <>
                    {c.class_status_code === "CANCELLED" ? (
                        <span className="d-block text-center">{t("classes.classCancelled")}</span>
                    ) : c.class_status_code === "AVAILABLE" ? (
                        moment().format() > moment(c.class_end_time).format() ? (
                            <span className="d-block text-center opacity-75">{t("classes.classesFinished")}</span>
                        ) : (
                            <>
                                {c.ifUserHasValidReservation ? (
                                    <Button
                                        disabled={disableBtn}
                                        size="sm"
                                        className={`btn-class btn-outline-${c.class_level_colour}`}
                                        onClick={() => getReservationDetails(c.class_id)}
                                    >
                                        {t("reservations.useReserv")}
                                    </Button>
                                ) : c.ifUserIsAssigned ? (
                                    <>
                                        {c.ifUserIsAssigned.u2c_status_code === "SIGNED" || c.ifUserIsAssigned.u2c_status_code === "WAITLIST" ? (
                                            <Button
                                                disabled={disableBtn}
                                                size="sm"
                                                className={`btn-class btn-outline-${c.class_level_colour}`}
                                                onClick={() => setShowSignOutModal({ c: c, statusCode: c.ifUserIsAssigned.u2c_status_code })}
                                            >
                                                {t("signOut")}
                                            </Button>
                                        ) : (
                                            <SignUpForClassBtns c={c} j={j} disableBtn={disableBtn} setDisableBtn={setDisableBtn} permissions={permissions} />
                                        )}
                                    </>
                                ) : (
                                    <SignUpForClassBtns c={c} j={j} disableBtn={disableBtn} setDisableBtn={setDisableBtn} permissions={permissions} />
                                )}
                            </>
                        )
                    ) : null}
                </>
            )}

            {showView.params.moduleName === "ADMIN_APP" && (
                <ScheduleAdminButtons permissions={permissions} c={c} j={j} getSchedule={getSchedule} filterDates={filterDates} setLoading={setLoading} reloadData={reloadData} />
            )}
            {showSignOutModal && (
                <SignOutFromClassModal
                    onClose={() => setShowSignOutModal(false)}
                    onProceed={() => {
                        setAlerts([{ variant: "info", message: t("info.signingOutFromClass") }]);
                        setTimeout(() => {
                            signOutFromClass(showSignOutModal.c);
                        }, 150);
                    }}
                    settings={settings}
                    c={showSignOutModal}
                />
            )}
        </Fragment>
    );
};

export default ActionBtns;
